import { InformationCircleIcon } from "@heroicons/react/24/outline";
import FileInputUploadFieldNew from "components/styledFormElements/FineInputUploadNew";
import InputField from "components/styledFormElements/InputField";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useObjectUrl } from "hooks/useObjectUrl";
import { OnboardingFormValues } from "containers/Protected/Settings/OnboardingSettings/interface";

const OtpVerificationSettings: React.FC = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<OnboardingFormValues>();

  const otp_watchedLogo = useWatch({ control, name: 'otp.v_image' })
  const vImagePreview = useObjectUrl(otp_watchedLogo)

  return (
    <div className="settings-card">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
            Top Image {<span className="text-red-700">*</span>}

            {(
              <span className="relative group ml-1 inline-block">
                <InformationCircleIcon className="w-4 h-4 text-slate-500 cursor-pointer inline" />
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 rounded-md bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 p-3 text-xs text-slate-700 dark:text-slate-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-50">
                  '2:3 aspect ratio',
                  'JPG / PNG',
                  '≤ 1 MB',
                </div>
              </span>
            )}
          </label>

          <FileInputUploadFieldNew
            name="otp.v_image"
            control={control}
            errors={errors}
            preview={vImagePreview}
            allowedTypes={[
              'image/jpeg',
              'image/png',
              'image/jpg',
            ]}
          />
        </div>
        <InputField
          label="Verification Title"
          required
          helpText='Main heading displayed on the OTP verification screen '
          placeholder="Enter verification title"
          type="text"
          register={register("otp.v_title")}
          error={errors?.otp?.v_title?.message}
        />
        <InputField
          label="Verification CTA Text"
          required
          helpText='Button text used to submit the entered OTP (e.g., "Verify", "Continue").'
          placeholder="Enter verification CTA text"
          type="text"
          register={register("otp.v_ctaText")}
          error={errors?.otp?.v_ctaText?.message}
        />
        <InputField
          label="Resend OTP Text"
          required
          helpText='Text shown for the resend OTP option (e.g., "Resend Code").'
          placeholder="Enter resend OTP text"
          type="text"
          register={register("otp.v_resend_otp_text")}
          error={errors?.otp?.v_resend_otp_text?.message}
        />
        <InputField
          label="OTP Time Text"
          required
          helpText='Label displayed before or alongside the countdown timer (e.g., "Resend OTP in", "Code expires in").'
          placeholder="Enter time text"
          type="text"
          register={register("otp.v_otp_time_text")}
          error={errors?.otp?.v_otp_time_text?.message}
        />
        <InputField
          label="OTP Time (in seconds)"
          required
          helpText='Set the OTP validity duration in seconds. Must be between 1 and 59 seconds.'
          placeholder="Enter time in seconds"
          type="number"
          min={1}
          max={59}
          register={register("otp.v_otp_time", { valueAsNumber: true })}
          error={errors?.otp?.v_otp_time?.message}
        />
      </div>
    </div>
  );
};

export default OtpVerificationSettings;
